const EventEmitter = require('events');

const notifier = new EventEmitter();
export default notifier;
